import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { getBankPromotionFromLocalStorage } from '@/data/Content/BanksPromotion';
import { useMemo } from 'react';

const NullElement = () => null;

export const LoginBanner = () => {
	const emsName = useMemo(() => {
		const bankPromotion = getBankPromotionFromLocalStorage();
		return bankPromotion ? `DPV2LoginBanner_${bankPromotion}` : 'unknown-login-banner';
	}, []);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{
				emsName,
			}}
			withoutFrame
			loadingElement={<NullElement />}
			emptyElement={<NullElement />}
		/>
	);
};
